module.exports = __webpack_public_path__ + "static/media/waterHeater.927b6355.svg";